module.exports = __webpack_public_path__ + "static/img/center_logo.ee5128e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cplan/center_logo.png
// module id = kv+y
// module chunks = 39